export enum CardLayout {
  HERO = 'hero',
  ROW = 'row',
  COLUMN = 'column',
}
